import { SimpleAnswerEnum } from '../../enums/entity.enum';
import { IClosedEndGPTargetInvestmentStat } from '../../interfaces/investment-vehicle/closed-end-gp-target-investment-stat.interface';

export class ClosedEndGPTargetInvestmentStat implements IClosedEndGPTargetInvestmentStat {
  closedEndDataFieldsId: number | undefined = undefined;

  //#region Portfolio Company Statistics (GP Provided)

  revenueRangeHigh: number | undefined = undefined;
  revenueRangeLow: number | undefined = undefined;
  ebitdaRangeHigh: number | undefined = undefined;
  ebitdaRangeLow: number | undefined = undefined;
  enterpriseValueRangeHigh: number | undefined = undefined;
  enterpriseValueRangeLow: number | undefined = undefined;
  equityInvestmentRangeHigh: number | undefined = undefined;
  equityInvestmentRangeLow: number | undefined = undefined;
  transactionMultipleHigh: number | undefined = undefined;
  transactionMultipleLow: number | undefined = undefined;
  transactionMultipleRevenueHigh: number | undefined = undefined;
  transactionMultipleRevenueLow: number | undefined = undefined;
  numPortfolioCompaniesHigh: number | undefined = undefined;
  numPortfolioCompaniesLow: number | undefined = undefined;

  //#endregion

  //#region Investment Details

  seedAssets: SimpleAnswerEnum | undefined = undefined;
  programEquityCommittedSeedAssets: number | undefined = undefined;
  maxDevelopment: number | undefined = undefined;
  targetHoldingPeriod: number | undefined = undefined;

  //#endregion

  boardSeats: SimpleAnswerEnum | undefined = undefined;
  numSeedInvestments: number | undefined = undefined;
  preferredCompanyValuationLow: number | undefined = undefined;
  preferredCompanyValuationHigh: number | undefined = undefined;
}
